// 🧊 장표 안 내용 자리 컨텍스트 — «모션 브리핑» 무대(`MotionBriefStage`)가 도형 목표 모양 안쪽을 인셋(px)으로 내려보낸다.
//   `useSafeArea`(layouts.tsx) 가 이 값이 있으면 세이프존 core 대신 이것을 쓴다 → 장표 10종이 코드 수정 없이 도형 안에 놓인다.
//   ★값이 없으면(무대 밖 = 기존 4종·MSB 트랙·정밀편집) 종전 세이프존 그대로★ — 기본값 null 이 바이트 불변의 근거다.
import { createContext, useContext } from 'react';

export interface SlideStageInset {
  top: number; bottom: number; left: number; right: number;
  /** 무대가 제목을 도형 위에 따로 띄운다 — 장표는 제목을 그리지 않는다(«큰 제목 분리» · 제목이 있는 목록형 5종). */
  hideTitle?: boolean;
  /** 촘촘한 체크리스트 — 보통 간격으로는 도형에 안 들어가 글자가 줄어들 때만(항목 간격 10 · 줄 높이 1.3). */
  compact?: boolean;
  /** 단계·카드 칸 계획 — 라벨 글자 크기(1920 기준 px)와 한 줄 칸 수(라벨이 한 줄로 드는 값 · motion-brief-shape `briefCellPlan`). */
  cells?: { labelPx: number; perRow: number };
}

export const SlideStageInsetContext = createContext<SlideStageInset | null>(null);

/** 무대가 제목을 대신 그리는가 — 무대 밖(null)은 false = 종전. */
export const useStageHidesTitle = (): boolean => useContext(SlideStageInsetContext)?.hideTitle === true;

/** 무대가 촘촘한 목록을 요구하는가 — 무대 밖(null)은 false = 종전. */
export const useStageCompact = (): boolean => useContext(SlideStageInsetContext)?.compact === true;

/** 무대가 정한 칸 계획 — 무대 밖(null)은 undefined = 종전. */
export const useStageCells = (): { labelPx: number; perRow: number } | undefined => useContext(SlideStageInsetContext)?.cells;

/** 🧊 경계 검사 표식(무대 안에서만) — `data-brief-cell` = 글자를 담는 칸 · `data-brief-label` = 한 줄이어야 하는 라벨.
 *  브라우저 전 프레임 검사(scripts/motion-brief/check-bounds)가 «글자 ⊂ 칸 · 라벨 한 줄»을 이 표식으로 잰다. 무대 밖은 빈 객체 = 종전 HTML. */
export const useStageMarks = (): { cell: Record<string, string>; label: Record<string, string> } =>
  useContext(SlideStageInsetContext) !== null
    ? { cell: { 'data-brief-cell': '' }, label: { 'data-brief-label': '' } }
    : { cell: {}, label: {} };
